import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";

const Modal = ({
  children,
  isOpen,
  onClose,
  size = "lg",
  header,
  headerClassName,
  bodyClassName,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (isOpen) {
      // Mount the component
      setShouldRender(true);
      setIsAnimating(false);
      // Trigger opening animation after mount
      const timer = setTimeout(() => setIsAnimating(true), 10);
      return () => clearTimeout(timer);
    } else {
      // Start closing animation
      setIsAnimating(false);
      // Delay unmounting to allow closing animation to complete
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300); // Match the transition duration
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const getSizeClassNames = () => {
    switch (size) {
      case "sm":
        return "w-1/2";
      case "md":
        return "w-1/2";
      case "lg":
        return "max-w-[670px]";
      case "xl":
        return "max-w-[830px]";
    }
  };

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed inset-0 bg-black flex items-center justify-center z-50 transition-opacity duration-300 ease-in-out ${
        isAnimating ? "bg-opacity-50 opacity-100" : "bg-opacity-0 opacity-0"
      }`}
      onClick={onClose}
    >
      <div
        className={`${getSizeClassNames()} w-full mx-4 bg-white rounded-3xl flex flex-col max-h-[90vh] transition-all duration-300 ease-in-out ${
          isAnimating
            ? "opacity-100 scale-100 translate-y-0"
            : "opacity-0 scale-95 translate-y-4"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header - Fixed */}
        <div
          className={`w-full flex flex-row items-center justify-between p-6 flex-shrink-0 border-b border-[#2734771A] ${
            headerClassName ?? ""
          }`}
        >
          {header}

          <button
            onClick={onClose}
            className="flex-shrink-0 hover:opacity-70 transition-opacity"
          >
            <Icon icon="mdi:times" className="w-5 h-5" />
          </button>
        </div>

        {/* Content - Scrollable */}
        <div
          className={`p-6 overflow-y-auto hide-scrollbar flex-1 ${
            bodyClassName ?? ""
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
